import { useQuery } from '@tanstack/react-query';
import { attentionCount } from '@/api/pipeline';
import { useAuth } from '@/auth/useAuth';
import { Badge } from '@/ui';
import { usePipelineLive } from './usePipelineLive';

/** Kept in the navigation so attention and live invalidation work away from the pipeline screen. */
export function PipelineAttentionBadge() {
  const { identity, user } = useAuth();
  usePipelineLive(user?.tenantId, identity);
  const count = useQuery({
    queryKey: ['pipeline', identity, 'attention-count'],
    queryFn: attentionCount,
  });
  return (
    <span
      className="pipeline-attention-label"
      aria-live="polite"
      title={count.error?.message}
      data-testid="pipeline-attention-count"
    >
      <Badge tone={count.data?.count ? 'warning' : 'neutral'}>
        {count.error
          ? 'Attention unavailable'
          : `${String(count.data?.count ?? '…')} need attention`}
      </Badge>
    </span>
  );
}
